export class TextMessageTemplate {
    id: number;
    fullName: string;
    description: string;
    placeholders: string;

    textBody: string;

    enabled: boolean;
    overridden: boolean;
}
